module.exports = __webpack_public_path__ + "img/cateicon1_a.809bd25c.svg";